import { useLayoutEffect, useRef } from 'react';

interface IRefFocus {
  setFocus: () => Promise<void>;
}
interface IUseAuthFocus {
  enabled?: boolean;
}
export const useAutoFocus = <T,>({ enabled = true }: IUseAuthFocus = {}) => {
  const ref = useRef<T>(null);
  useLayoutEffect(() => {
    if (enabled) {
      setTimeout(() => {
        const el = ref.current as IRefFocus;
        el?.setFocus();
      }, 150);
    }
  }, [enabled]);
  return ref;
};
